import { useQuery } from '@tanstack/react-query'
import { useAuth } from '../../state/auth'
import { apiFetch } from '../../lib/api'

type DashboardStats = {
  employeesCount: number
  simulationsCount: number
  terminationsCount: number
}

export function DashboardPage() {
  const { me, selectedCompanyId } = useAuth()

  const effectiveCompanyId = selectedCompanyId ?? me?.memberships?.[0]?.companyId ?? null
  const company = me?.memberships.find((m) => m.companyId === effectiveCompanyId)

  const statsQ = useQuery({
    queryKey: ['dashboard-stats', effectiveCompanyId],
    enabled: !!effectiveCompanyId,
    queryFn: () =>
      apiFetch<DashboardStats>(`/companies/${effectiveCompanyId}/dashboard-stats`)
  })

  const stats = statsQ.data
  const loading = statsQ.isLoading && !!effectiveCompanyId

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xl font-semibold text-slate-900">Dashboard</div>
        <div className="mt-1 text-sm text-slate-500">
          {company ? `Empresa selecionada: ${company.companyName}` : 'Selecione uma empresa para começar.'}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <div className="text-sm font-semibold text-slate-900">Funcionários</div>
          <div className="mt-2 text-2xl font-semibold text-slate-900">
            {!effectiveCompanyId ? '—' : loading ? '…' : (stats?.employeesCount ?? '—')}
          </div>
          <div className="mt-1 text-xs text-slate-500">Cadastrados na empresa selecionada.</div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <div className="text-sm font-semibold text-slate-900">Simulações</div>
          <div className="mt-2 text-2xl font-semibold text-slate-900">
            {!effectiveCompanyId ? '—' : loading ? '…' : (stats?.simulationsCount ?? '—')}
          </div>
          <div className="mt-1 text-xs text-slate-500">Histórico de custo do funcionário.</div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <div className="text-sm font-semibold text-slate-900">Rescisões</div>
          <div className="mt-2 text-2xl font-semibold text-slate-900">
            {!effectiveCompanyId ? '—' : loading ? '…' : (stats?.terminationsCount ?? '—')}
          </div>
          <div className="mt-1 text-xs text-slate-500">Histórico de cálculos de rescisão.</div>
        </div>
      </div>
    </div>
  )
}

